/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _buttons = __webpack_require__(1);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _watcher = __webpack_require__(2);
	
	var _watcher2 = _interopRequireDefault(_watcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isTouch = false;
	if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch) {
	  isTouch = true;
	  $('body').addClass('touch-device');
	}
	
	var buildSlider = function buildSlider($slider) {
	  $slider.each(function (index, elm) {
	    var slider = $(elm);
	    slider.find('.slide').addClass('swiper-slide');
	    slider.addClass('swiper-wrapper');
	    slider.wrap('<div class="swiper-container ' + $slider.attr('data-slider') + '"></div>');
	    $('<div class="swiper-pagination"></div>').insertAfter(slider);
	    $('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>').insertAfter(slider);
	  });
	};
	
	var destroySlider = function destroySlider($slider) {
	  var $container = $slider.parent(),
	      $duplicate = $container.find('[class*="swiper-slide-duplicate"]');
	
	  $container.find('.swiper-button-prev').remove();
	  $container.find('.swiper-button-next').remove();
	  $container.find('.swiper-pagination').remove();
	  $container.find('.swiper-slide-duplicate').remove();
	  $container.find('.swiper-slide').removeClass('swiper-slide');
	  $duplicate.removeClass('swiper-slide-duplicate-prev');
	  $duplicate.removeClass('swiper-slide-duplicate-next');
	  $container.find('.swiper-wrapper').removeClass('swiper-wrapper');
	  $slider.unwrap();
	};
	
	var buttons = new _buttons2.default({
	  selectors: ['.button-primary', '.newsletter-toggle'],
	  onlyOneActive: true
	});
	
	$('body').on('click.primaryClose', function (event) {
	  if ($('html').hasClass('button-primary-active')) {
	    var $target = $(event.target);
	    if ($target.closest('.primary-wrapper').length < 1 && $target.closest('.toggle-container').length < 1) {
	      $('.button-primary').trigger('click');
	    }
	  }
	});
	
	var sliderOptions = {
	  speed: 400,
	  pagination: '.swiper-pagination',
	  resistanceRatio: 0,
	  prevButton: '.swiper-button-prev',
	  nextButton: '.swiper-button-next'
	  //loop: true
	};
	
	buildSlider($('[data-slider="slider"]'));
	var mySlider = new Swiper('.swiper-container', sliderOptions);
	
	var introslider = function () {
	  var $slider = $('#intro-slider'),
	      timeout;
	
	  var setPaginationPosition = function setPaginationPosition() {
	    var images = $slider.find('.swiper-slide').first().find('img'),
	        imgHeight;
	
	    images.each(function (index, elm) {
	      if ($(elm).is(':visible')) {
	        imgHeight = $(elm).height();
	      }
	    });
	
	    $slider.parent().find('.swiper-pagination').css({
	      top: imgHeight - 50
	    });
	  };
	  setPaginationPosition();
	
	  $(window).on('load', function () {
	    setPaginationPosition();
	  });
	
	  $(window).on('resize', function () {
	    clearTimeout(timeout);
	    timeout = setTimeout(function () {
	      setPaginationPosition();
	    }, 20);
	  });
	}();
	
	var mobileSlider = function () {
	  var $slider = $('[data-slider="slider_m"]'),
	      sliderOnPage = $slider.length > 0 ? true : false,
	      mobileSwiper;
	
	  var match = function match() {
	    // Destroy mobileSlider
	    if (sliderOnPage && mobileSwiper) {
	      mobileSwiper.destroy(true, true);
	      destroySlider($slider);
	    }
	  },
	      dismatch = function dismatch() {
	    if (sliderOnPage) {
	      // Build mobileSlider
	      buildSlider($slider);
	      mobileSwiper = new Swiper('.slider_m', sliderOptions);
	    }
	  },
	      query = new _watcher2.default({
	    breakpoint: 768,
	    match: match,
	    dismatch: dismatch
	  });
	}();
	
	var reveal = function () {
	  $('.reveal-onload').addClass('revealed');
	
	  var $reveal = $('.reveal'),
	      $body = $('body'),
	      timeout;
	
	  $reveal.each(function (inde, elm) {
	    var $elm = $(elm);
	    var waypoint = new Waypoint({
	      element: $elm,
	      handler: function handler(direction) {
	        var $thisElm = $(this.element);
	        if (!$thisElm.data('isRevealed')) {
	          $thisElm.addClass('revealed').data('isRevealed', true);
	        }
	
	        $(document).trigger('waypoint', [direction, $thisElm]);
	      },
	      offset: '65%'
	    });
	  });
	
	  $(window).on('resize', function () {
	    clearTimeout(timeout);
	    timeout = setTimeout(function () {
	      Waypoint.refreshAll();
	    }, 20);
	  });
	}();
	
	var ajaxLoad = function () {
	  var $ajax = $('.ajax-load');
	  $ajax.each(function (index, elm) {
	    var $elm = $(elm);
	    $elm.attr('src', $elm.attr('data-src'));
	  });
	}();
	
	var checkScrollPos = function checkScrollPos() {
	  var query = location.search;
	  if (location.search) {
	    var hash = query.substr(query.indexOf('c=') + 2, query.length),
	        hashArray = hash.split('&'),
	        hashSection = hashArray[0],
	        index = $('#' + hashSection).index();
	    $('.subpage-menu li').eq(index).find('a').trigger('click');
	  }
	};
	
	var subPage = function () {
	  var $body = $('body');
	
	  if (!$body.hasClass('subpage')) {
	    return;
	  }
	
	  var isMobile,
	      timeOut,
	      orientation,
	      counter = 0,
	      $hero = $('#my-hero');
	
	  var $mainArticle = $('.main-article'),
	      $firstWrapper = $mainArticle.eq(0).find('> .wrapper'),
	      $subSection = $('.subpage-section');
	
	  var checkOrientation = function checkOrientation() {
	    if ($(window).width() > $(window).height()) {
	      orientation = 'landscape';
	    } else {
	      orientation = 'portrait';
	    }
	  };
	
	  var handleSubpageWaypoints = function handleSubpageWaypoints(direction, element) {
	    var $parent = element.parent(),
	        index = $parent.index(),
	        oldHash = $parent.prev().attr('id'),
	        newHash = $parent.attr('id');
	
	    var query = location.search,
	        hash = query.substr(query.indexOf('c=') + 2, query.length),
	        hashArray = hash.split('&');
	
	    if (direction == 'down') {
	      $body.attr('data-subactive', index + 1);
	
	      if (history.replaceState) {
	        $(hashArray).each(function (index, elm) {
	          if (index !== 0) {
	            newHash += '&' + elm;
	          }
	        });
	        history.replaceState(null, null, '?c=' + newHash);
	      }
	    } else {
	      $body.attr('data-subactive', index);
	
	      if (index + 1 == 2) {
	        $body.removeAttr('data-subactive');
	      }
	
	      if (history.replaceState) {
	        $(hashArray).each(function (index, elm) {
	          if (index !== 0) {
	            oldHash += '&' + elm;
	          }
	        });
	
	        if (index === 1 && hashArray.length === 1) {
	          history.replaceState(null, null, location.href.split("?")[0]);
	        } else {
	          history.replaceState(null, null, '?c=' + oldHash);
	        }
	      }
	    }
	  };
	
	  $(document).on('waypoint', function (event, direction, index) {
	    handleSubpageWaypoints(direction, index);
	  });
	
	  var setHeightsOfSubpages = function setHeightsOfSubpages() {
	    $mainArticle.each(function (index, sel) {
	      var $sel = $(sel),
	          windowHeight = $(window).height(),
	          oldArticleHeight,
	          articleHeight,
	          topPos;
	
	      $sel.removeAttr('style');
	      oldArticleHeight = $sel.outerHeight();
	
	      if (isMobile) {
	        if (index === 0) {
	          topPos = $sel.offset().top;
	          articleHeight = windowHeight - Math.round(topPos);
	        } else {
	          articleHeight = windowHeight - Math.round($hero.outerHeight());
	        }
	      } else {
	        if (index === 0) {
	          articleHeight = windowHeight - Math.round($('.subpage-menu').outerHeight());
	        } else {
	          articleHeight = windowHeight;
	        }
	      }
	
	      if (articleHeight > oldArticleHeight) {
	        $sel.css({ height: articleHeight });
	      }
	    });
	  };
	
	  var match = function match() {
	    counter += 1;
	    isMobile = false;
	    $(document).scrollTop(0);
	    $body.removeAttr('data-subactive').removeClass('sticky-hero');
	    $firstWrapper.removeAttr('style');
	  },
	      dismatch = function dismatch() {
	    counter += 1;
	    isMobile = true;
	    $(document).scrollTop(0);
	    $body.removeAttr('data-subactive');
	  },
	      query = new _watcher2.default({
	    breakpoint: 1024,
	    match: match,
	    dismatch: dismatch
	  });
	
	  setHeightsOfSubpages();
	
	  var subPageMenu = function subPageMenu() {
	    var $link = $('.subpage-menu a');
	    $link.on('click', function (event) {
	      event.preventDefault();
	
	      var $thisLink = $(event.target),
	          target = $thisLink.attr('href'),
	          targetId = target.substr(1, target.length),
	          topPos = $(target).offset().top;
	
	      if (isMobile) {
	        topPos -= $hero.outerHeight();
	      }
	
	      $('html,body').animate({
	        scrollTop: Math.round(topPos)
	      });
	    });
	  };
	
	  subPageMenu();
	  checkScrollPos();
	
	  $(window).on('resize', function () {
	    if (!isTouch) {
	      $(document).scrollTop(0);
	      $body.removeAttr('data-subactive');
	      history.replaceState(null, null, location.href.split("?")[0]);
	    }
	    clearTimeout(timeOut);
	    timeOut = setTimeout(function () {
	
	      if (counter >= 2 && isMobile) {
	        location.reload();
	      }
	
	      setHeightsOfSubpages();
	      Waypoint.refreshAll();
	    }, 50);
	  });
	
	  $body.addClass('subpage-ready');
	}();
	
	var collapse = function () {
	  $('.collapse').on('click', function (event) {
	    event.preventDefault();
	    $(event.target).toggleClass('expanded');
	    return false;
	  });
	}();
	
	var wallsScroll = function () {
	  var $window = $(window),
	      timeout,
	      postsAvailable = true;
	
	  if (!$('body').hasClass('walls')) {
	    return;
	  }
	  $(document).on("WallsioNoMorePosts", function () {
	    postsAvailable = false;
	  });
	
	  $window.on('scroll.walls', function () {
	    clearTimeout(timeout);
	    timeout = setTimeout(function () {
	      if ($window.scrollTop() + 400 >= $(document).height() - $window.height()) {
	        if (postsAvailable) {
	          Wallsio.loadMorePosts(4);
	        }
	      }
	    }, 100);
	  });
	}();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The Name of the Module
	 */
	var moduleName = 'Buttons';
	
	/**
	 * Class default values
	 */
	var defaults = {
	  selectors: ['.button'],
	  onlyOneActive: false,
	  classSuffix: '-active'
	};
	
	/**
	 * class Buttons Module
	 */
	
	var Buttons = function () {
	
	  /**
	   * constructor of Buttons Class
	   */
	  function Buttons(options) {
	    _classCallCheck(this, Buttons);
	
	    this._prepare(options);
	  }
	
	  /**
	   * prepare Function
	   * Extend Default, Save Selectors, EventHandlers
	   */
	
	
	  _createClass(Buttons, [{
	    key: '_prepare',
	    value: function _prepare(options) {
	      var self = this;
	
	      // Extend default options
	      self.options = $.extend(true, defaults, options);
	      self.$html = $('html');
	
	      // Save selectors ECMS 5 (iE9)
	      self.options.selectors.forEach(function (i) {
	        self.selectors = self.selectors ? self.selectors.add(i) : $(i);
	      });
	
	      // Set the Click event on the selectors
	      self.selectors.on('click.' + moduleName, function (event) {
	        event.preventDefault();
	        var $this = $(event.currentTarget);
	
	        if ($this.data('toggle') === 'on') {
	          self.toggleOff($this);
	        } else {
	          self.toggleOn($this);
	          if (options.onlyOneActive && self.options.selectors.length > 1) {
	            self.toggleOff(self._getOtherButtons($this));
	          }
	        }
	
	        return false;
	      });
	    }
	
	    /**
	     * Get all other Buttons
	     * @param {Object} [$elm] clicked Button
	     */
	
	  }, {
	    key: '_getOtherButtons',
	    value: function _getOtherButtons($elm) {
	      var $otherButtons = void 0,
	          count = 0;
	
	      this.options.selectors.forEach(function (i) {
	        if (i !== '.' + $elm.attr('class')) {
	          count++;
	          $otherButtons = count === 1 ? $(i) : $otherButtons.add(i);
	        }
	      });
	
	      return $otherButtons;
	    }
	
	    /**
	     * Toggle on Button and set active class
	     * @param {Object} [$elm] clicked Button
	     */
	
	  }, {
	    key: 'toggleOn',
	    value: function toggleOn($elm) {
	      var self = this,
	          options = self.options,
	          elmClass = $elm.attr('class');
	
	      $(document).trigger(elmClass + '-on');
	      //$(document).scrollTop(0);
	
	      // Set Data Info to Toggle On
	      $elm.data('toggle', 'on');
	      self.$html.addClass(elmClass + options.classSuffix);
	    }
	
	    /**
	     * Toggle off Button and remove active class
	     * @param {Object} [$elm] clicked Button
	     */
	
	  }, {
	    key: 'toggleOff',
	    value: function toggleOff($elm) {
	      var self = this,
	          options = self.options;
	
	      $elm.each(function (index, value) {
	        var $this = $(value),
	            elmClass = $this.attr('class');
	
	        $(document).trigger(elmClass + '-off');
	        //$(document).scrollTop(0);
	
	        // Set Data Info to Toggle Off
	        $this.data('toggle', 'off');
	        self.$html.removeClass(elmClass + options.classSuffix);
	      });
	    }
	  }]);
	
	  return Buttons;
	}();
	
	exports.default = Buttons;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Watcher = function Watcher(query) {
	  var mediaQuery = window.matchMedia('(min-width:' + query.breakpoint + 'px)'),
	      watch = function watch(mediaQuery) {
	    if (mediaQuery.matches) {
	      query.match();
	    } else {
	      query.dismatch();
	    }
	  };
	
	  mediaQuery.addListener(watch);
	  watch(mediaQuery);
	};
	
	exports.default = Watcher;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js